/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum InvoiceState {
  SENT = "sent",
  REMINDER_SENT = "reminderSent",
  CLOSED = "closed",
}
